var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.layerTimesteps)?_c('div',{staticClass:"child",staticStyle:{"height":"400px"}},[_c('div',{staticClass:"child",style:({
      top: 0,
      bottom: 0,
      width: '100%',
      height: '100%'
    }),attrs:{"id":_vm.container}},[_c('v-select',{staticClass:"layer-selector",attrs:{"items":_vm.months,"label":"Select Month","item-value":"value","item-text":"label","dense":"","single-line":"","flat":"","solo":""},model:{value:(_vm.selectedMonth),callback:function ($$v) {_vm.selectedMonth=$$v},expression:"selectedMonth"}}),_c('v-img',{staticClass:"legend-image",attrs:{"src":_vm.legendImage}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }